import * as React from "react";
import Modal from "@mui/material/Modal";
import * as style from "./Styled";

import PhotoCardComponent from "./PhotoCardComponent";
import TitleCardComponent from "./TitleCardComponent";
import { useDispatch, useSelector } from "react-redux";
import { createBoard } from "../../../Services/boardsService";
import LoadingScreen from "../../LoadingScreen";

export default function CreateBoard(props) {
  const dispatch = useDispatch();
  const creating = useSelector((state) => state.boards.creating);
  const { backgroundImages, smallPostfix } = useSelector((state) => state.boards);
  const defaultBackground = backgroundImages[0] + smallPostfix;
  const [open, setOpen] = React.useState(true);
  const [background, setBackground] = React.useState(defaultBackground);
  const [newBoard, setNewBoard] = React.useState({
    title: "",
    backgroundImageLink: defaultBackground,
    members: [],
  });

  const handleClick = async () => {
    await createBoard(newBoard, dispatch);
    props.callback();
  };

  const handleSelect = (link) => {
    setBackground(link);
    setNewBoard((prev) => ({
      ...prev,
      backgroundImageLink: link,
    }));
  };

  const handleClose = () => {
    setOpen(false);
    props.callback();
  };

  const handleUpdate = (updatedBoard) => {
    setNewBoard(updatedBoard);
  };

  return (
    <div style={{ position: "relative" }}>
      {creating && <LoadingScreen />}
      <Modal open={open} onClose={handleClose} disableEnforceFocus>
        <style.Container>
          <style.Surface>
            <style.Header>
              <style.HeaderTitle>Create a new board</style.HeaderTitle>
              <style.HeaderText>Pick a background, add a title, and invite your teammates.</style.HeaderText>
            </style.Header>
            <style.Wrapper>
              <TitleCardComponent link={background} updateback={handleUpdate} callback={handleClose} />
              <style.PhotosPane>
                <style.PhotosTitle>Backgrounds</style.PhotosTitle>
                <style.PhotosCard>
                  {backgroundImages.map((item, index) => (
                    <PhotoCardComponent
                      key={index}
                      selectedLink={background}
                      link={item + smallPostfix}
                      callback={handleSelect}
                    />
                  ))}
                </style.PhotosCard>
              </style.PhotosPane>
            </style.Wrapper>
            <style.CreateButton onClick={handleClick} disabled={!newBoard.title}>
              {creating ? "Creating..." : "Create Board"}
            </style.CreateButton>
          </style.Surface>
        </style.Container>
      </Modal>
    </div>
  );
}
